import { render, staticRenderFns } from "./VehicleManage.vue?vue&type=template&id=38d9e094&scoped=true&"
import script from "./VehicleManage.vue?vue&type=script&lang=js&"
export * from "./VehicleManage.vue?vue&type=script&lang=js&"
import style0 from "./VehicleManage.vue?vue&type=style&index=0&id=38d9e094&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d9e094",
  null
  
)

export default component.exports